import { createSlice, current } from "@reduxjs/toolkit";
const deviceModelList = [
  {
    "name": "DAP-E9560",
    "hwVer": "A1",
    "deviceCategory": "ap"
  },
  {
    "name": "DAP-X3060OU",
    "hwVer": "A1",
    "deviceCategory": "ap"
  },
  {
    "name": "DGS-1100-10MPPV2",
    "hwVer": "A1",
    "deviceCategory": "switch"
  },
  {
    "name": "DXS-1210-10TS",
    "hwVer": "B1",
    "deviceCategory": "switch"
  },
  {
    "name": "DXS-1210-16TC",
    "hwVer": "B1",
    "deviceCategory": "switch"
  },
  {
    "name": "DGS-1250-28XMP",
    "hwVer": "F",
    "deviceCategory": "switch"
  },
  {
    "name": "DXS-1210-10TS",
    "hwVer": "F",
    "deviceCategory": "switch"
  },
]

export const deviceModelListSlice = createSlice({
  name: "deviceModelList",
  initialState: {
    resource: "deviceModelList",
    data: deviceModelList,
    total: deviceModelList.length
  },
  reducers: {},
});

export const {} = deviceModelListSlice.actions;

export default deviceModelListSlice.reducer;
